var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 126,
    viewBox: "0 0 27 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_58_19139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 3.57728C5 2.26524 6.59055 1.61291 7.5118 2.54711L21.5775 16.8106C21.8482 17.0851 22 17.4552 22 17.8407V92.2174C22 92.477 21.9311 92.732 21.8003 92.9563L7.73463 117.083C6.98027 118.377 5 117.842 5 116.344V3.57728Z",
    fill: "#DDC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 3.57728C5 2.26524 6.59055 1.61291 7.5118 2.54711L21.5775 16.8106C21.8482 17.0851 22 17.4552 22 17.8407V92.2174C22 92.477 21.9311 92.732 21.8003 92.9563L7.73463 117.083C6.98027 118.377 5 117.842 5 116.344V3.57728Z",
    stroke: "#DDC8FF",
    strokeWidth: 0.366787,
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.876 15.4023V95.7288",
    stroke: "url(#paint0_linear_58_19139)",
    strokeWidth: 0.183394,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4883 12.8398L17.7539 99.7688",
    stroke: "url(#paint1_linear_58_19139)",
    strokeWidth: 0.183394,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3555 10.6367V103.801",
    stroke: "url(#paint2_linear_58_19139)",
    strokeWidth: 0.183394,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2402 8.80469V106.737",
    stroke: "url(#paint3_linear_58_19139)",
    strokeWidth: 0.183394,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1074 6.60156V110.769",
    stroke: "url(#paint4_linear_58_19139)",
    strokeWidth: 0.183394,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9834 4.76953L8.71326 114.439",
    stroke: "url(#paint5_linear_58_19139)",
    strokeWidth: 0.183394,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59473 2.57031L6.3291 118.109",
    stroke: "url(#paint6_linear_58_19139)",
    strokeWidth: 0.183394,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8184 74.8926V77.1133H13.6523V74.8926C13.6523 74.5059 13.5898 74.1934 13.4648 73.9551C13.3398 73.7168 13.168 73.543 12.9492 73.4336C12.7266 73.3203 12.4727 73.2637 12.1875 73.2637C11.918 73.2637 11.666 73.3203 11.4316 73.4336C11.1934 73.543 11.002 73.7168 10.8574 73.9551C10.7129 74.1934 10.6406 74.5059 10.6406 74.8926V76.6621H18V78.1328H9.46875V74.8926C9.46875 74.2324 9.58594 73.6719 9.82031 73.2109C10.0508 72.7461 10.3711 72.3926 10.7812 72.1504C11.1875 71.9082 11.6523 71.7871 12.1758 71.7871C12.7266 71.7871 13.1992 71.9082 13.5938 72.1504C13.9883 72.3926 14.291 72.7461 14.502 73.2109C14.7129 73.6719 14.8184 74.2324 14.8184 74.8926ZM12.8672 69.1914H18V70.6035H11.6602V69.2559L12.8672 69.1914ZM11.6191 67.252L12.9316 67.2637C12.916 67.3496 12.9043 67.4434 12.8965 67.5449C12.8887 67.6426 12.8848 67.7402 12.8848 67.8379C12.8848 68.0801 12.9199 68.293 12.9902 68.4766C13.0566 68.6602 13.1543 68.8145 13.2832 68.9395C13.4082 69.0605 13.5605 69.1543 13.7402 69.2207C13.9199 69.2871 14.1211 69.3262 14.3438 69.3379L14.3672 69.6602C13.9688 69.6602 13.5996 69.6211 13.2598 69.543C12.9199 69.4648 12.6211 69.3477 12.3633 69.1914C12.1055 69.0312 11.9043 68.832 11.7598 68.5938C11.6152 68.3516 11.543 68.0723 11.543 67.7559C11.543 67.6699 11.5508 67.5781 11.5664 67.4805C11.582 67.3789 11.5996 67.3027 11.6191 67.252ZM14.9004 66.7891H14.7656C14.3086 66.7891 13.8848 66.7227 13.4941 66.5898C13.0996 66.457 12.7578 66.2656 12.4688 66.0156C12.1758 65.7617 11.9492 65.4531 11.7891 65.0898C11.625 64.7227 11.543 64.3086 11.543 63.8477C11.543 63.3828 11.625 62.9688 11.7891 62.6055C11.9492 62.2383 12.1758 61.9277 12.4688 61.6738C12.7578 61.4199 13.0996 61.2266 13.4941 61.0938C13.8848 60.9609 14.3086 60.8945 14.7656 60.8945H14.9004C15.3574 60.8945 15.7813 60.9609 16.1719 61.0938C16.5625 61.2266 16.9043 61.4199 17.1973 61.6738C17.4863 61.9277 17.7129 62.2363 17.877 62.5996C18.0371 62.9629 18.1172 63.375 18.1172 63.8359C18.1172 64.3008 18.0371 64.7168 17.877 65.084C17.7129 65.4473 17.4863 65.7559 17.1973 66.0098C16.9043 66.2637 16.5625 66.457 16.1719 66.5898C15.7812 66.7227 15.3574 66.7891 14.9004 66.7891ZM14.7656 65.377H14.9004C15.1855 65.377 15.4551 65.3477 15.709 65.2891C15.9629 65.2305 16.1855 65.1387 16.377 65.0137C16.5684 64.8887 16.7188 64.7285 16.8281 64.5332C16.9375 64.3379 16.9922 64.1055 16.9922 63.8359C16.9922 63.5742 16.9375 63.3477 16.8281 63.1562C16.7188 62.9609 16.5684 62.8008 16.377 62.6758C16.1855 62.5508 15.9629 62.459 15.709 62.4004C15.4551 62.3379 15.1855 62.3066 14.9004 62.3066H14.7656C14.4844 62.3066 14.2188 62.3379 13.9688 62.4004C13.7148 62.459 13.4902 62.5527 13.2949 62.6816C13.0996 62.8066 12.9473 62.9668 12.8379 63.1621C12.7246 63.3535 12.668 63.582 12.668 63.8477C12.668 64.1133 12.7246 64.3438 12.8379 64.5391C12.9473 64.7305 13.0996 64.8887 13.2949 65.0137C13.4902 65.1387 13.7148 65.2305 13.9688 65.2891C14.2188 65.3477 14.4844 65.377 14.7656 65.377ZM18 57.8945V59.3125H11.25C10.7383 59.3125 10.3066 59.2109 9.95508 59.0078C9.60352 58.8008 9.33594 58.5059 9.15234 58.123C8.96875 57.7363 8.87695 57.2773 8.87695 56.7461C8.87695 56.4336 8.91016 56.1328 8.97656 55.8438C9.04297 55.5508 9.12695 55.248 9.22852 54.9355L10.377 55.1523C10.3105 55.3516 10.248 55.5723 10.1895 55.8145C10.127 56.0566 10.0957 56.3359 10.0957 56.6523C10.0957 57.0781 10.1934 57.3926 10.3887 57.5957C10.5801 57.7949 10.8672 57.8945 11.25 57.8945H18ZM11.6602 56.623H12.6914L12.6914 60.2852H11.6602L11.6602 56.623ZM11.6602 54.2676H18V55.6797H11.6602V54.2676ZM9 51.1797H18V52.5977H9V51.1797ZM18.1172 46.8379C18.1172 47.3066 18.041 47.7305 17.8887 48.1094C17.7324 48.4844 17.5156 48.8047 17.2383 49.0703C16.9609 49.332 16.6348 49.5332 16.2598 49.6738C15.8848 49.8145 15.4805 49.8848 15.0469 49.8848H14.8125C14.3164 49.8848 13.8672 49.8125 13.4648 49.668C13.0625 49.5234 12.7188 49.3223 12.4336 49.0645C12.1445 48.8066 11.9238 48.502 11.7715 48.1504C11.6191 47.7988 11.543 47.418 11.543 47.0078C11.543 46.5547 11.6191 46.1582 11.7715 45.8184C11.9238 45.4785 12.1387 45.1973 12.416 44.9746C12.6895 44.748 13.0156 44.5801 13.3945 44.4707C13.7734 44.3574 14.1914 44.3008 14.6484 44.3008H15.252V49.1992H14.2383V45.6953H14.127C13.873 45.7031 13.6348 45.7539 13.4121 45.8477C13.1895 45.9375 13.0098 46.0762 12.873 46.2637C12.7363 46.4512 12.668 46.7012 12.668 47.0137C12.668 47.248 12.7188 47.457 12.8203 47.6406C12.918 47.8203 13.0605 47.9707 13.248 48.0918C13.4355 48.2129 13.6621 48.3066 13.9277 48.373C14.1895 48.4355 14.4844 48.4668 14.8125 48.4668H15.0469C15.3242 48.4668 15.582 48.4297 15.8203 48.3555C16.0547 48.2773 16.2598 48.1641 16.4355 48.0156C16.6113 47.8672 16.75 47.6875 16.8516 47.4766C16.9492 47.2656 16.998 47.0254 16.998 46.7559C16.998 46.416 16.9297 46.1133 16.793 45.8477C16.6562 45.582 16.4629 45.3516 16.2129 45.1562L16.9336 44.4121C17.1328 44.5488 17.3242 44.7266 17.5078 44.9453C17.6875 45.1641 17.834 45.4316 17.9473 45.748C18.0605 46.0605 18.1172 46.4238 18.1172 46.8379Z",
    fill: "#30313A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_58_19139",
    x: 0.816406,
    y: 1.92383,
    width: 25.3672,
    height: 124.074,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_58_19139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_58_19139",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_58_19139",
    x1: 19.376,
    y1: 15.4023,
    x2: 19.376,
    y2: 95.7288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_58_19139",
    x1: 16.9883,
    y1: 12.8428,
    x2: 17.4948,
    y2: 99.7703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_58_19139",
    x1: 14.8555,
    y1: 10.6367,
    x2: 14.8555,
    y2: 103.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_58_19139",
    x1: 12.7402,
    y1: 8.80469,
    x2: 12.7402,
    y2: 106.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_58_19139",
    x1: 10.6074,
    y1: 6.60156,
    x2: 10.6074,
    y2: 110.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_58_19139",
    x1: 8.4834,
    y1: 4.76718,
    x2: 7.96832,
    y2: 114.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_58_19139",
    x1: 6.09473,
    y1: 2.56812,
    x2: 5.58826,
    y2: 118.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#667EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8859B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.11ff43c80cde6098218728f0a6d2497b.svg";
export { ForwardRef as ReactComponent };